module.exports = __webpack_public_path__ + "img/missing-img.6f4e0b4b.svg";